import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//elementUI及样式
import Element from 'element-ui'

import './themes/common.scss'
import 'remixicon/fonts/remixicon.css'




Vue.use(Element, {
  size: 'small'
});
//标签页
import RouterTab from 'vue-router-tab'
Vue.use(RouterTab)
//自定义指令，过滤器，组件导入
import '@/common/directive.js'
import '@/common/filter.js'
import '@/common/components.js'
import '@/common/currentrow.js'
//请求接口
import http from '@/common/ajax.js'
Vue.prototype.$get = http.get;
Vue.prototype.$post = http.post;
Vue.prototype.$put = http.put;
Vue.prototype.$delete = http.dele;
Vue.prototype.$download = http.download;
//vuex
import initStore from '@/common/initStore.js';
import initSignlR from '@/common/signalr.js'
if (sessionStorage.getItem('token')) {
  initStore();
  initSignlR();
}
//全局变量
import global from '@/global';
Vue.prototype.$g = global;
//功能权限
import hasPermission from '@/common/hasPermission.js';
Vue.prototype.auth = hasPermission;

Vue.config.productionTip = false
//打印组件
import print from '@/components/Print';
Vue.component("print", print);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')